import styles from "./infoCard.module.scss";
export function InfoCard({
  imgSrc = "",
  altText = "",
  ctaLabel = "",
  ctaUrl = "",
  description = "",
}) {
  return (
    <div
      className={styles.cardContainer}
      onClick={(e) => {
        e.preventDefault();
        window.open(ctaUrl, "_blank");
      }}
    >
      <img alt={altText} src={imgSrc} className={styles.cardImage} />
      <p className={styles.cardDescription}>{description}</p>
      <button className={styles.cardCta}>
        {ctaLabel}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.6022 0.602507C13.4055 -0.200836 14.708 -0.200836 15.5113 0.602507L27.511 12.6022C27.8968 12.988 28.1135 13.5112 28.1135 14.0568C28.1135 14.6023 27.8968 15.1256 27.511 15.5113L15.5113 27.511C14.708 28.3144 13.4055 28.3144 12.6022 27.511C11.7988 26.7077 11.7988 25.4052 12.6022 24.6019L21.0902 16.1138H2.05709C0.920989 16.1138 0 15.1929 0 14.0568C0 12.9207 0.920989 11.9997 2.05709 11.9997H21.0902L12.6022 3.51167C11.7988 2.70832 11.7988 1.40585 12.6022 0.602507Z"
            fill="#F00"
          />
        </svg>
      </button>
    </div>
  );
}
